import { fetchEventSource } from "@microsoft/fetch-event-source";
/**
 * 将 SSE 事件流转换为异步迭代器。
 */
export async function createSSEStream(url, options) {
  // Reference https://github.com/withspectrum/callback-to-async-iterator/blob/master/src/index.js
  const pushQueue = [];
  const pullQueue = [];
  let disposed = false;
  let closed = false;
  const {
    converter,
    ...fetchOptions
  } = options !== null && options !== void 0 ? options : {};
  await new Promise((resolve, reject) => {
    fetchEventSource(url, {
      ...fetchOptions,
      openWhenHidden: true,
      async onopen(response) {
        if (response.ok) {
          resolve(null);
        } else {
          var _json;
          // eslint-disable-next-line no-console
          console.error("open error", response.statusText);
          let text;
          try {
            text = await response.text();
          } catch {
            throw new Error(response.statusText);
          }
          let json;
          try {
            json = JSON.parse(text);
          } catch {
            // Do nothing
          }
          if (typeof ((_json = json) === null || _json === void 0 ? void 0 : _json.error) === "string") {
            throw new Error(json.error);
          }
          throw new Error(text);
        }
      },
      onmessage(msg) {
        // istanbul ignore next
        if (process.env.NODE_ENV === "development") {
          // eslint-disable-next-line no-console
          console.debug("[EventSource]", msg);
        }
        let data;
        let reason;
        let ok = true;
        try {
          data = (converter !== null && converter !== void 0 ? converter : defaultConverter)(msg.data, msg.event);
        } catch (e) {
          ok = false;
          reason = e;
        }
        if (pullQueue.length > 0) {
          const [resolve, reject] = pullQueue.shift();
          ok ? resolve(data) : reject(reason);
        } else {
          pushQueue.push(ok ? {
            ok: true,
            data: data
          } : {
            ok: false,
            reason
          });
        }
      },
      onclose() {
        closed = true;
        earlyDone();
      },
      onerror(err) {
        throw err;
      }
    }).catch(reason => {
      reject(reason);
      bailout(reason);
    });
  });
  function bailout(reason) {
    pullQueue.forEach(_ref => {
      let [_resolve, reject] = _ref;
      return reject(reason);
    });
    dispose();
  }
  function earlyDone() {
    pullQueue.forEach(_ref2 => {
      let [resolve] = _ref2;
      return resolve({
        value: undefined,
        done: true
      });
    });
  }
  function dispose() {
    disposed = true;
    pullQueue.length = 0;
    pushQueue.length = 0;
  }
  return {
    next() {
      return disposed ? this.return() : new Promise((resolve, reject) => {
        if (pushQueue.length > 0) {
          const result = pushQueue.shift();
          if (result.ok) {
            resolve(result.data);
          } else {
            reject(result.reason);
          }
        } else if (closed) {
          dispose();
          resolve({
            value: undefined,
            done: true
          });
        } else {
          pullQueue.push([resolve, reject]);
        }
      });
    },
    return() {
      earlyDone();
      dispose();
      return Promise.resolve({
        value: undefined,
        done: true
      });
    },
    throw(error) {
      earlyDone();
      dispose();
      return Promise.reject(error);
    },
    [Symbol.asyncIterator]() {
      return this;
    }
  };
}
function defaultConverter(data, event) {
  if (event === "error") {
    var _value;
    // eslint-disable-next-line no-console
    console.error("Received error event:", data);
    let value;
    try {
      value = JSON.parse(data);
    } catch {
      // Ignore
    }
    throw new Error(typeof ((_value = value) === null || _value === void 0 ? void 0 : _value.error) === "string" ? value.error : data);
  }

  // By default, `data: [DONE]` indicates the end of the stream
  if (data === "[DONE]") {
    return {
      value: undefined,
      done: true
    };
  }
  if (data.startsWith("[ERROR]")) {
    // eslint-disable-next-line no-console
    console.error("Received error message:", data);
    throw new Error(data);
  }
  try {
    const value = JSON.parse(data);
    return {
      value,
      done: false
    };
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error("Failed to parse message:", data);
    throw e;
  }
}
//# sourceMappingURL=createSSEStream.js.map